<template>

    <v-page-section>

        <template #title>Two-Factor Authentication</template>

        <template v-if="!qrCode" #body>
            <v-form-group label="Authy" caption="Use the Authy app to add an extra layer of security to your account.">
                <v-button v-if="!activated" btn-label="Enable 2FA" size="sm" :loading="loading" @click.native="generate"></v-button>
                <v-button v-else btn-label="Disable 2FA" size="sm" btn-style="danger" :loading="loading" @click.native="deactivate"></v-button>
            </v-form-group>
        </template>

        <template v-else #body>
            <v-form-group label="Configuration" caption="Scan this code with the Authy app.">
                <img :src="'data:image/png;base64,' + qrCode" width="300" height="300" style="border:1px solid #222;" />
                <p class="mt-10"><a href="https://authy.com/download/" target="_blank">Download the free Authy app</a></p>
            </v-form-group>
            <v-form-group label="Token" caption="Enter the token displayed on the Authy app.">
                <form @submit.prevent="register">
                    <v-input-with-button class="w-300">
                        <template #input>
                            <v-input class="w-300" maxlength="6" placeholder="XXXXXX" :model="token" @input="token = $event"></v-input>
                        </template>
                        <template #button>
                            <v-button btn-label="Submit" size="sm" :loading="loading" @click.native="register"></v-button>
                        </template>
                    </v-input-with-button>
                </form>
            </v-form-group>
        </template>

    </v-page-section>

</template>

<script>

import AuthyApi from '@api/AuthyApi';

export default {

    data() {
        return {
            loading: false,
            qrCode: null,
            token: null,
            activated: false,
        }
    },

    computed: {

        user() {
            return this.$store.getters.user;
        },

    },

    mounted() {
        this.activated = Boolean(this.user.authy_activated_at);
    },

    methods: {

        generate() {
            this.loading = true;
            AuthyApi.generate()
                .then((response) => {
                    this.loading = false;
                    this.qrCode = response.data.data;
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

        register() {
            this.loading = true;
            AuthyApi.register(this.token)
                .then((response) => {
                    this.loading = false;
                    this.qrCode = null;
                    this.activated = true;
                    this.$store.commit('setAlertSuccess', this.$t('message.acivated'));
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

        deactivate() {
            this.loading = true;
            AuthyApi.deactivate()
                .then((response) => {
                    this.loading = false;
                    this.activated = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.deacivated'));
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

}

</script>
